import { ReactNode } from 'react';

export enum TOOLTIP_TRIGGERS {
  HOVER = 'hover',
  CLICK = 'click',
  NONE = 'none',
}

export enum TOOLTIP_TYPE {
  COPY = 'copy',
  INFO = 'info',
}

export enum TOOLTIP_POSITION {
  ABSOLUTE = 'absolute',
  FIXED = 'fixed',
  PORTAL = 'portal',
}

export enum TOOLTIP_DURATION {
  SMALL = 2000,
  MEDIUM = 3000,
  LARGE = 5000,
  VERY_LARGE = 10000,
  EXTRA_LARGE = 60000,
}

export interface ICustomTooltipProps {
  message: string;
  messageOption?: Record<string, string>;
  type: TOOLTIP_TYPE;
  triggerType: TOOLTIP_TRIGGERS;
  position: TOOLTIP_POSITION;
  duration: number;
  trigger?: boolean; // if changes to true, it becomes visible for a set duration
  disableTrigger?: () => void;
  show: boolean;
  permanentVisible?: boolean;
  disabled?: boolean;
  copyData?: string | number;
  //
  minWidth?: string | number;
  maxWidth?: string | number;
  gapTop: number;
  className?: string;
  wrapperClassName?: string;
  contentClassName?: string;
  messageClassName?: string;
  tooltipClassName?: string;
  children?: ReactNode;
}
